export const makeFolderPath = ({ name: designatedName, id = null }, currentFolder, makeCopy = true) => {
  if (makeCopy) {
    const exists = currentFolder.children.find((folder) => (!id || folder.id !== id) && folder.name === designatedName)
    if (exists) {
      const copies = currentFolder.children.filter((folder) => (!id || folder.id !== id) && folder.name.split(`${designatedName} (`)[1])
      if (copies.length) {
        const names = copies.map(({ name }) => name.split(`${designatedName} (`)[1])
        const numbers = names.map((n) => {
          const value = +n.split(')')[0]
          return isNaN(value) ? 0 : value
        })
        const max = numbers.sort((a, b) => b - a)[0]
        designatedName = `${designatedName} (${max + 1})`
      } else if (currentFolder.children.find((folder) => folder.name === designatedName)) {
        designatedName = `${designatedName} (1)`
      }
    }
  }

  let path = designatedName
  if (currentFolder.name) {
    const prePath = currentFolder.path
      ? `${currentFolder.path}/${currentFolder.name}`
      : currentFolder.name
    path = `${prePath}/${designatedName}`
  }

  return path
}
